import { gql } from '@apollo/client'

import { STORE_FRAGMENT } from '../fragments'

export const GET_TENANT_STORES = gql`
  query GetTenantStores(
    $filters: StoreFilter
    $order: StoreOrder
    $pagination: OffsetPaginationInput
  ) {
    tenantStores(filters: $filters, order: $order, pagination: $pagination) {
      results {
        ...Store
      }
      pageInfo {
        limit
        offset
      }
      totalCount
    }
  }
  ${STORE_FRAGMENT}
`
